import * as React from 'react';

/**
 * This is not tested! Use at your own risk.
 */
export function useDebouncedEffect(callback: () => void | Promise<void>, timeout: number, deps: React.DependencyList): void {

  // This deps array was noncompliant before we enabled the lint rule.
  // The better thing to do might be to require the caller to memoize the callback, instead of
  // doing it in the hook.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const throttled = React.useCallback(callback, deps);

  React.useEffect(
    () => {
      const handler = setTimeout(() => void throttled(), timeout);
      return () => clearTimeout(handler);
    },
    // This deps array was noncompliant before we enabled the lint rule.
    // It's probably safe to add `throttled` to the array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [callback, timeout]
  );
}
